import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { DialpadComponent } from './dialpad/dialpad.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  exports:[
    DialpadComponent
  ],
  declarations: [
    DialpadComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule
  ],
  
  
})
export class PartialsModule {}
